import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserSessionService } from '@core/services/user-session.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  protected readonly session = inject(UserSessionService);
}
